import PropTypes from 'prop-types';
import React from 'react';

//helpers
import {styleable} from 'decorators';

//styled-components
import {Icon} from './styles';

const AbstractIconComponent = styleable(({icons, name, ...forwardedProps}) => (
  <Icon
    {...forwardedProps}
    className={`icon ${name}`}
    dangerouslySetInnerHTML={{__html: icons[name] || icons.default}}
  />
));

AbstractIconComponent.defaultProps = {
  name: 'default',
  shouldInheritTextColor: true,
  size: 24,
  valign: 'middle'
};

AbstractIconComponent.propTypes = {
  icons: PropTypes.objectOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
  shouldInheritTextColor: PropTypes.bool,
  size: PropTypes.number
};

export default AbstractIconComponent;
